module.exports = __webpack_public_path__ + "static/1d089953ee2e85364afb1851d3ae4e3f.svg";